import React from 'react'

function SvgCalendar() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M1.95833 5.92855H13.625M3.46627 1V2.28586M11.9583 1V2.28571M14.4583 4.53571V13.75C14.4583 14.9926 13.4634 16 12.2361 16H3.34722C2.11992 16 1.125 14.9926 1.125 13.75V4.53571C1.125 3.29307 2.11992 2.28571 3.34722 2.28571H12.2361C13.4634 2.28571 14.4583 3.29307 14.4583 4.53571Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default SvgCalendar